import { Toaster as Sonner, toast } from "sonner"

const Toaster = ({
  ...props
}) => {
  return (
    <Sonner
      theme="light"
      className="toaster group"
      position="top-right"
      toastOptions={{
        classNames: {
          toast:
            "group toast group-[.toaster]:bg-white group-[.toaster]:text-[#02160D] group-[.toaster]:border-[#E5D5C1] group-[.toaster]:shadow-lg",
          description: "group-[.toast]:text-[#536A61]",
          actionButton:
            "group-[.toast]:bg-[#007668] group-[.toast]:text-white",
          cancelButton:
            "group-[.toast]:bg-[#FEF6E8] group-[.toast]:text-[#02160D]",
          success: "group-[.toaster]:border-[#007668]",
          error: "group-[.toaster]:border-[#E85F16]",
        },
      }}
      {...props} />
  );
}

export { Toaster, toast }
